import { Heading, HeadingTag } from "./Heading";

type ImportantInformationProps = {
  title: string;
  list: string[];
};

export const ImportantInformation = ({
  title,
  list,
}: ImportantInformationProps) => (
  <div className="imp-info">
    <Heading
      tag={HeadingTag.h2}
      size={2}
      className="zb-heading2"
      title="Important information"
    ></Heading>
    <p className="imp-info-sub-heading">
      <strong>{title}</strong>
    </p>
    <ul>
      {list.map((item, i) => (
        <li key={i} className="imp-info-list">
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
);
